mobileSize = 1130;

$(document).ready(function () {
    const windowSize = $(window).width();
    if (windowSize < 1131) {
        $('body')
        .addClass('saffireMobileSize')
        .removeClass('saffireLargeSize');
    } if (windowSize > 1130) {
        $('body').removeClass('saffireMobileSize');
    }
    $('.footer .saffire_logo').attr('src', FULLCLIENTTHEMEPATH + '/images/saffire-logo.png');
     
    // General Message
    $('.generalmessage').prependTo('header'); 
     
     // -------------BLUE RIBBON SPONSORS HIDE CONDITION
  setTimeout(() => {
    let count = $(".blue-ribbon-sponsors-container #venue-widget .sponsorWidgetContainer .sponsorCarouselImageContainer a").children().length / 2;
    if (count <= 0) {
      $('.blue-ribbon-sponsors-container').addClass('hidingComponent')
    }

  }, 5000)
  $(".footerItems1 a").removeClass("button");
  $(".saffireMobileSize .footerItems1 a").removeClass("button");
  $(".saffireMobileSize .got-img").insertBefore( $(".saffireMobileSize .footer-navigation"));
  
 // Feature Lineup 
$(".featureLineupContainer").each(function() {
  var row_obj = this;
var titles = $(row_obj).find('.subContainer').find('span.featureLineup-title').detach();
var btns = $(row_obj).find('.featureLineup-buttons').find('.featureLineup-more').detach();
var socialbtn = $(row_obj).find('.featureLineup-buttons').find('.featureLineup-social').detach();
var destext = $(row_obj).find('.featureLineupImage a:eq(1)').find('.featureLineup-text').detach();

$(row_obj).find('.subContainer').find('.featureLineupImage').prepend(titles);
$(row_obj).find('.subContainer').find('.featureLineupImage').prepend(destext);
$(row_obj).find('.subContainer').find('.featureLineupImage').append(btns);
$(row_obj).find('.subContainer').find('.featureLineupImage').append(socialbtn); 
});
   
  // description text
  $(".featureLineup-text").text(function(){
    return $(this).text().length > 120 ? $(this).text().substr(0, 120)+'...' : $(this).text();
  });

});

// window resize

$(window).resize(function(){
  // got div
    $(".saffireMobileSize .footer .mob-got-container").prepend( $(".saffireMobileSize .footer .got-img"));
    $(`.footer .got-img`).attr({
      "data-aos": "fade-left",
      "data-aos-easing": "ease-in-out",
      "data-aos-duration": "550",
      "data-aos-delay": "200",
      "data-aos-once": "true"

})
});

$(window).load(function () { 
  $(".saffireMobileSize .footerItems1 a").removeClass("button");
  $(".header .searchBoxInput input").attr("placeholder", "Search Website");  
   $(".saffireMobileSize .footer .mob-got-container").prepend( $(".saffireMobileSize .footer .got-img"));
   $(`.footer .got-img`).attr({
        "data-aos": "fade-left",
        "data-aos-easing": "ease-in-out",
        "data-aos-duration": "550",
        "data-aos-delay": "200",
        "data-aos-once": "true"

  })
});

// footer navigation split
$(function($) {
  var num_cols = 2,
  container = $('.saffireLargeSize .bottom.footerItems1'),
  listItem = 'li',
  listClass = 'sub-list';
  container.each(function() {
      var items_per_col = new Array(),
      items = $(this).find(listItem),
      min_items_per_col = Math.floor(items.length / num_cols),
      difference = items.length - (min_items_per_col * num_cols);
      for (var i = 0; i < num_cols; i++) {
          if (i < difference) {
              items_per_col[i] = min_items_per_col + 1;
          } else {
              items_per_col[i] = min_items_per_col;
          }
      }
      for (var i = 0; i < num_cols; i++) {
          $(this).append($('<ul ></ul>').addClass(listClass));
          for (var j = 0; j < items_per_col[i]; j++) {
              var pointer = 0;
              for (var k = 0; k < i; k++) {
                  pointer += items_per_col[k];
              }
              $(this).find('.' + listClass).last().append(items[j + pointer]);
          }
      }
  });
});